module.exports = __webpack_public_path__ + "portal/assets/img/logo.5f331d3c.svg";